import { Component, isDevMode } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs/Subscription";
import { OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { environment } from "../environments/environment.prod";
import { ApiService, AdminService } from "./api/services";
import { TextService } from "./shared/text.service";
import { NgxLocalizedNumbersService } from "ngx-localized-numbers";
import { AuthenticationService } from "./authentication/authentication.service";
import { Router } from '@angular/router';
import {
  User,
  Translation,
  Constructors,
  Units,
  MonetaryCurrency,
  Langue,
  DefaultEquipment,
  Profile,
} from "./api/models";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {
  title = "app";
  private subscription: Subscription;
  public userLogon: User;
  public langname: string;

  constructor(
    private router: Router,
    private auth: AuthenticationService,
    public translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    api: ApiService,
    text: TextService,
    private localizedNumbersService: NgxLocalizedNumbersService,
    private apiAdmin: AdminService
  ) {
    translate.addLangs(["en", "fr", "es", "it", "de"]);
    this.apiAdmin.getCurrentUser().subscribe(
      (data) => {
        if (Number(data.CODE_LANGUE) === 1) {
          this.langname = "en";
        } else if (Number(data.CODE_LANGUE) === 2) {
          this.langname = "fr";
        } else if (Number(data.CODE_LANGUE) === 3) {
          this.langname = "it";
        } else if (Number(data.CODE_LANGUE) === 4) {
          this.langname = "de";
        } else if (Number(data.CODE_LANGUE) === 5) {
          this.langname = "es";
        }
        translate.setDefaultLang(this.langname);
        translate.use(this.langname);
        this.userLogon = data;
      },
      (err) => {
        //console.log("getCurrentUser false",err.status);
        // this.auth.logout();
        this.router.navigate(['/auth/signin']);
      },
      () => {
        // console.log("getCurrentUser true");
      }
    );
    text.initialize();
  }

  ngOnInit() {
    this.localizedNumbersService.setLocale("en_US");
    // subscribe to router event
    this.subscription = this.activatedRoute.queryParams.subscribe(
      (param: any) => {
        const locale = param["locale"];
        if (locale !== undefined) {
          this.translate.use("locale");
          console.log("change locale to: " + locale);
        }
      }
    );
  }

  ngOnDestroy() {
    // prevent memory leak by unsubscribing
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/app.component.ts